/* eslint-disable @typescript-eslint/no-explicit-any */
import api from '@/api';

import { API_BASE_URL } from '..';

import {
  CreateSendOptionData,
  CrmSendOptionCommunication,
  CrmSendOptionCommunicationWithBilling,
  CrmSendOptionCommunicationWithVehicle,
  CrmSendOptionFutureServiceCommunication,
  CrmSendOptionNextReviewCommunication,
  EditSendOptionData,
  ListSendOptionParams,
  ListSendOptionResponse,
  SendOption,
} from './SendOptions.types';

const controller = 'sendoptions';
const baseUrl = `${API_BASE_URL}/${controller}`;

export async function listSendOption(params?: ListSendOptionParams) {
  const result = (await api.get(baseUrl, params)) as unknown;

  return result as ListSendOptionResponse;
}

export async function createSendOption(data: CreateSendOptionData) {
  const result = (await api.post(baseUrl, data, null)) as unknown;

  return result as SendOption;
}

export async function detailSendOption(quizId: number) {
  const result = (await api.get(`${baseUrl}/${quizId}`, null)) as unknown;

  return result as SendOption;
}

export async function editSendOption(
  optionId: number,
  data: EditSendOptionData,
) {
  const result = (await api.put(
    `${baseUrl}/${optionId}`,
    data,
    null,
  )) as unknown;

  return result as SendOption;
}

export async function removeSendOption(quizId: number) {
  const result = (await api.remove(
    `${baseUrl}/${quizId}`,
    {},
    null,
  )) as unknown;

  return result as any;
}

export async function sendOptionCommunication(
  data: CrmSendOptionCommunication,
) {
  const result = (await api.post(
    `${baseUrl}/comunication-async`,
    data,
    null,
  )) as unknown;

  return result as SendOption;
}

export async function sendOptionCommunicationWithVehicle(
  data: CrmSendOptionCommunicationWithVehicle,
) {
  const result = (await api.post(
    `${baseUrl}/comunication-with-vehicle-async`,
    data,
    null,
  )) as unknown;

  return result as SendOption;
}

export async function sendOptionCommunicationWithBilling(
  data: CrmSendOptionCommunicationWithBilling,
) {
  const result = (await api.post(
    `${baseUrl}/billing-comunication-async`,
    data,
    null,
  )) as unknown;

  return result as SendOption;
}

export async function sendOptionFutureServicesCommunication(
  data: CrmSendOptionFutureServiceCommunication,
) {
  const result = (await api.post(
    `${baseUrl}/future-services-comunication-async`,
    data,
    null,
  )) as unknown;

  return result as SendOption;
}

export async function sendOptionNextReviewsCommunication(
  data: CrmSendOptionNextReviewCommunication,
) {
  const result = (await api.post(
    `${baseUrl}/next-reviews-comunication-async`,
    data,
    null,
  )) as unknown;

  return result as SendOption;
}
